const styles = () => ({
    container: {
        height: 'auto',
        padding: '1em 2em 2em 2em',
    },
    containerForm: {
        position: 'relative',
        marginTop: '30px',
        alignItems: 'center',
    },
    containerInt: {
        margin: '0 auto',
    },
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '10px 12px 0 12px',
        display: 'flex',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    colorWhite: {
        color: '#fff',
    },
    boxTextField: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: '0px !important',
    },
    boxRecoveryInfo: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '0px !important',
        textAlign: 'center',
    },
    icone: {
        margin: '20px 10px 0 0',
    },
});

export default styles;
